import React, { FC } from "react";

import { KpkMedia } from "@keepeek/commons";
import { BaseComponentProps } from "@keepeek/refront-components";
import { alpha, Box, Typography } from "@mui/material";
import clsx from "clsx";

type MediaDetailHeaderMetaFieldProps = {
  media: KpkMedia;
  fields: Array<string>;
} & BaseComponentProps;

const MediaDetailHeaderMetaField: FC<React.PropsWithChildren<MediaDetailHeaderMetaFieldProps>> =
  function (props) {
    const fieldsToDisplay = [...props.fields];
    return (
      <Box className={clsx("MediaDetailHeaderMetaField", props.className)}>
        {fieldsToDisplay.map((fctField) => {
          const metaField = props.media.fields?.find((f) => f.id === fctField);
          if (metaField) {
            return (
              <Typography
                key={metaField.id}
                title={metaField.name}
                variant="subtitle1"
                component="h2"
                noWrap
                sx={{
                  color: (theme) => alpha(theme.palette.text.primary, 0.5),
                  lineHeight: 1.2,
                }}
              >
                {metaField.value}
              </Typography>
            );
          } else {
            return null;
          }
        })}
      </Box>
    );
  };

export default MediaDetailHeaderMetaField;
